import classNames from 'classnames';
import React from 'react';
import Rating from '../rating';

interface PropTypes {
  className?: string;
  image?: string;
  rating?: number;
  title: string;
  description?: React.ReactNode;
  link?: string;
}

const InlineProductTemplate: React.FC<PropTypes> = ({
  className,
  image,
  rating,
  title,
  description,
}) => {
  return (
    <>
      <div className={classNames(className, 'flex items-center')}>
        <div className="relative w-24 xl:w-32">
          <img className="w-full" src={image} alt={title} />
        </div>
        <div className="flex w-4/5 flex-1 flex-col lg:flex-row">
          <div className="mx-auto w-full max-w-xl lg:mx-0">
            {typeof rating === 'number' && <Rating value={rating} />}
            <div className="flex-col pl-4 leading-tight md:pt-4 lg:pl-8">
              <h1 className="text-primary-main font-black sm:text-lg md:text-base lg:font-medium">
                {title}
              </h1>
              {description && <div className="text-sm">{description}</div>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default InlineProductTemplate;
